/**
 * Helper function to convert storage path to full public URL
 * @param profilePhotoPath - Storage path like "{tenantId}/{fileName}" or full URL
 * @returns Full public URL or undefined
 */
export function getProfilePhotoUrl(
  profilePhotoPath: string | null | undefined
): string | undefined {
  if (!profilePhotoPath) return undefined;

  // If it's already a full URL, return as-is (backward compatibility)
  if (profilePhotoPath.startsWith('http://') || profilePhotoPath.startsWith('https://')) {
    return profilePhotoPath;
  }

  // Convert storage path to full URL
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) return undefined;

  // Path format: "{tenantId}/{fileName}"
  return `${supabaseUrl}/storage/v1/object/public/profile-photos/${profilePhotoPath}`;
}

/**
 * Helper function to extract storage path from full URL
 * @param url - Full public URL
 * @returns Storage path like "{tenantId}/{fileName}" or original URL if extraction fails
 */
export function extractStoragePathFromUrl(url: string): string {
  // If it's already a path (no http), return as-is
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return url;
  }

  // Extract path from URL
  // URL format: https://{supabase-url}/storage/v1/object/public/profile-photos/{tenantId}/{fileName}
  const match = url.match(/\/profile-photos\/(.+)$/);
  if (match && match[1]) {
    return match[1];
  }

  // If extraction fails, return original URL (backward compatibility)
  return url;
}
